import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { AuthProvider, FirebaseAppProvider, FirestoreProvider } from 'reactfire';
import { firebaseConfig } from './utils/firebaseConfig';
import { PrivateRoute } from './components/PrivateRoute';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import config from './utils/config';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';
import { ToastContainer } from 'react-toastify';

import './styles/App.scss';
import "bootstrap-icons/font/bootstrap-icons.css"
import 'react-toastify/dist/ReactToastify.css';
import { InvoicesPage } from './pages/InvoicesPage';
import AzureLoginHandlerPage from './pages/AzureLoginHandlerPage';
import { PATHS } from './utils/shared/constants';
import AdminPage from './pages/AdminPage';
import GoodsOwnerSettingsPage from "./pages/GoodsOwnerSettingsPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <PrivateRoute><InvoicesPage /></PrivateRoute>,
  },
  {
    path: "/azure",
    element: <PrivateRoute><AzureLoginHandlerPage /></PrivateRoute>
  },
  {
    path: PATHS.ADMIN,
    element: <PrivateRoute><AdminPage /></PrivateRoute>,
  }, {
    path: `${PATHS.SETTINGS}/:ix`,
    element: <PrivateRoute><GoodsOwnerSettingsPage /></PrivateRoute>,
  }
]);


const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const firestore = getFirestore(firebaseApp);

if (config.useEmulators) {
  console.log('Connecting to emulators');
  connectFirestoreEmulator(firestore, 'localhost', 8080);
  connectAuthEmulator(auth, "http://localhost:9099")
}

function App() {

  return <FirebaseAppProvider firebaseConfig={firebaseConfig}>
    <AuthProvider sdk={auth}>
      <FirestoreProvider sdk={firestore}>
        <RouterProvider router={router} />
        <ToastContainer />
      </FirestoreProvider>
    </AuthProvider>
  </FirebaseAppProvider>
}


export default App;
